import { AuthContext } from "core/contexts/auth/auth";
import {
  deleteIndexSubmittal,
  getAllIndicesSubmittal,
} from "modules/agentMySecurity/services/embeddingsService";
import { useContext, useEffect, useState } from "react";
import AdvanceSearch from "core/components/global/advanceSearch/advanceSearch";
import { SimpleTableContainer } from "modules/agentMySecurity/components/admin/admin.styled";
import AdminGroup from ".";
import { Toast as showToast } from "core/components/global/toast/toast";
import { IconButton } from "@mui/material";
import { RefreshIcon } from "assets/RefreshIcon";
import NoResultsFound from "core/components/global/tables/noResults/noResultsFound";

export default function FetchIndecies() {
  const { checkAuthToken } = useContext(AuthContext);
  const [indices, setIndices] = useState<string[]>([]);
  const [filteredIndicies, setfilteredIndicies] = useState<string[] | null>(
    null
  );
  const [loading, setIsLoading] = useState<boolean>(false);
  const [copyOfSearchValue, setCopyOfSearchValue] = useState("");

  // Make a call to fetch indices
  const fetchIndices = async () => {
    const token = await checkAuthToken();

    // Fetch the data form the backend
    const response = await getAllIndicesSubmittal(token);

    if (response === null) {
      // If the try catch is triggered, show the update
      showToast("Cannot fetch indicies at this time", "error");
    } else {
      if (response.hasOwnProperty("error")) {
        // If the backend returns an error message, show the update
        showToast("Cannot fetch indicies at this time", "error");
      } else {
        // Set the indicies
        setIndices(response.indices);
      }
    }
  };

  const reloadIndecies = () => {
    // Start the loading animation
    setIsLoading(true);
    fetchIndices();
  };

  useEffect(() => {
    // Tell the loading icon to complete 1 revolution and then stop
    // the .styles has the animation take 1k milliseconds fo 1 revolution
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [indices]);

  useEffect(() => {
    // on the opening of this component run fetchIndecies
    fetchIndices();
  }, []);

  const handleFilterData = (newKeys, b, c) => {
    setfilteredIndicies(newKeys);
  };

  const handleClearFilter = () => {
    setfilteredIndicies(null);
  };

  /**
   * Delete the selected index
   * @param indexName
   */
  async function handleDeleteIndex(formName) {
    const token = await checkAuthToken();
    const response = await deleteIndexSubmittal(token, formName);

    if (response === null) {
      // If the try catch is triggered, show the update
      showToast("Cannot delete the index at this time", "error");
    } else {
      if (response.hasOwnProperty("error")) {
        // If the backend returns an error message, show the update
        showToast("Cannot delete the index at this time", "error");
      } else {
        // For the local, filter out the deleted item
        const newIndecies = indices.filter((name) => name !== formName);

        // Update the local
        setIndices(newIndecies);

        // Show the update
        showToast("Successfully deleted the row", "success");
      }
    }
  }

  return (
    <SimpleTableContainer
      elevation={1}
      className="w-100 align-self-baseline mt-3"
      columns={1}
    >
      {/* Data Search */}
      <div className="pb-3 d-flex justify-content-between align-items-center ">
        <h5>Show Indecies</h5>
        <div className="d-flex flex-row">
          <AdvanceSearch
            initialData={indices}
            setFilteredData={handleFilterData}
            clearFilteredData={handleClearFilter}
            setCopyOfSearchValue={setCopyOfSearchValue}
          />

          <div className="ms-3 row-buttons">
            <IconButton
              aria-label="send prompt"
              onClick={() => reloadIndecies()}
              edge="end"
              className={`me-1 icon-button round ${loading && "loading"}`}
            >
              <RefreshIcon />
            </IconButton>
          </div>
        </div>
      </div>

      {/* Collapsable Table */}
      <div aria-label="collapsible table">
        {/* Headers */}
        <div
          style={{ borderRadius: "5px 5px 0 0" }}
          className="outer-header-container"
        >
          <div className="row-items">
            <p className="header-item">Name</p>
          </div>
          <div className="row-buttons"></div>
        </div>

        {/* Body */}
        <div
          style={{ borderRadius: "0 0 5px 5px" }}
          className="outer-row-container"
        >
          {(filteredIndicies === null ? indices : filteredIndicies).length >
          0 ? (
            // Itterate the invites
            filteredIndicies === null ? (
              <>
                {indices.map((indexItem, i) => (
                  // Row items
                  <AdminGroup
                    key={`row-${indexItem}-${i}`}
                    indexItem={indexItem}
                    deleteIndex={handleDeleteIndex}
                  />
                ))}
              </>
            ) : (
              <>
                {filteredIndicies.map((indexItem, i) => (
                  // Row items
                  <AdminGroup
                    key={`row-${indexItem}-${i}`}
                    indexItem={indexItem}
                    deleteIndex={handleDeleteIndex}
                  />
                ))}
              </>
            )
          ) : (
            // If no results, show the NoResultsFound component
            <NoResultsFound
              searchTerm={filteredIndicies !== null ? copyOfSearchValue : ""}
            />
          )}
        </div>
      </div>
    </SimpleTableContainer>
  );
}
